require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./measure-57-drug-courts.json") })
        }
      }, "path---measure-57-drug-courts");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---measure-57-drug-courts!./.cache/json/measure-57-drug-courts.json
// module id = 933
// module chunks = 231608221292675